import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from "@clerk/clerk-react";

import App from './App';
import './index.css';
import './i18n';
import qubiqLogo from './assets/logo.png';

import { TransactionProvider } from './context/TransactionContext';
import i18n from './i18n';
import { getClerkLocalization } from './i18n/clerkLocalization';
import { normalizeToSupportedLanguage } from './i18n/config';
import { clerkGlobalAppearance } from './utils/clerkAppearance';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Starts the immutable navbar logo request before React renders the application.
if (typeof window !== 'undefined') {
  const logoPreload = new Image();
  logoPreload.src = qubiqLogo;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const RootProviders = () => {
  const [language, setLanguage] = useState(() =>
    normalizeToSupportedLanguage(i18n.resolvedLanguage || i18n.language)
  );

  useEffect(() => {
    const handleLanguageChanged = (nextLanguage) => {
      setLanguage(normalizeToSupportedLanguage(nextLanguage));
    };

    i18n.on("languageChanged", handleLanguageChanged);

    return () => {
      i18n.off("languageChanged", handleLanguageChanged);
    };
  }, []);

  return (
    <ClerkProvider
      publishableKey={clerkPubKey}
      localization={getClerkLocalization(language)}
      appearance={clerkGlobalAppearance}
    >
      <TransactionProvider>
        <App />
      </TransactionProvider>
    </ClerkProvider>
  );
};

root.render(
  <RootProviders />
);
